import React from 'react';
import { MessageCircle, ArrowRight, Send } from 'lucide-react';
import { Button } from './ui/button';

const telegramPosts = [
  {
    id: 1,
    title: 'Как справиться с тревожностью',
    excerpt: 'Практические советы по управлению тревогой и стрессом в повседневной жизни. Читайте в моём Telegram-канале...',
    image: 'https://images.pexels.com/photos/3807517/pexels-photo-3807517.jpeg'
  },
  {
    id: 2,
    title: 'Психологическая поддержка ребёнка',
    excerpt: 'Как помочь ребёнку адаптироваться к школе и справиться со страхами...',
    image: 'https://images.pexels.com/photos/4101143/pexels-photo-4101143.jpeg'
  },
  {
    id: 3,
    title: 'Путь к лучшей версии себя',
    excerpt: 'Как начать работу над собой и достичь внутренней гармонии...',
    image: 'https://images.pexels.com/photos/3760607/pexels-photo-3760607.jpeg'
  }
];

const TelegramBlogSection = () => {
  const telegramLink = 'https://t.me/IrinAntonovna';

  return (
    <section className="py-16 md:py-24 bg-sand-50 section-contrast">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="mb-10 flex flex-col gap-6 md:mb-12 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-teal-600 font-medium tracking-[0.3em] uppercase text-xs mb-3">
              Блог
            </p>
            <h2 className="text-3xl md:text-4xl font-serif text-stone-800 mb-2">
              Полезные статьи
            </h2>
            <p className="text-stone-600">
              Читайте больше в моём Telegram-канале
            </p>
          </div>
          <a
            href={telegramLink}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full md:w-auto"
          >
            <Button className="w-full bg-sky-500 px-6 py-5 text-white hover:bg-sky-600 md:w-auto rounded-lg">
              <MessageCircle size={20} className="mr-2" />
              Подписаться на Telegram
            </Button>
          </a>
        </div>

        {/* Posts Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {telegramPosts.map((post) => (
            <a
              key={post.id}
              href={telegramLink}
              target="_blank"
              rel="noopener noreferrer"
              className="group block"
            >
              <article className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300">
                <div className="relative overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    width="800"
                    height="200"
                    loading="lazy"
                    decoding="async"
                    className="w-full h-[200px] object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4 bg-sky-500 text-white text-xs font-medium px-3 py-1 rounded-full flex items-center gap-1">
                    <Send size={12} />
                    Telegram
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-stone-800 mb-2 group-hover:text-teal-600 transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-stone-600 text-sm mb-4 line-clamp-2">
                    {post.excerpt}
                  </p>
                  <span className="inline-flex items-center text-teal-600 text-sm font-medium">
                    Читать в Telegram
                    <ArrowRight size={16} className="ml-1 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </article>
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 text-center md:mt-12">
          <div className="flex flex-col items-start gap-4 rounded-2xl bg-gradient-to-r from-sky-500 to-sky-600 p-6 text-white md:flex-row md:items-center md:p-8">
            <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center">
              <MessageCircle size={28} />
            </div>
            <div className="text-left">
              <p className="font-semibold text-lg">Подписывайтесь на мой Telegram-канал</p>
              <p className="text-sky-100 text-sm">Полезные статьи, советы и поддержка</p>
            </div>
            <a
              href={telegramLink}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full md:ml-4 md:w-auto"
            >
              <Button variant="secondary" className="w-full bg-white px-6 py-5 text-sky-600 hover:bg-sky-50 md:w-auto">
                Подписаться
                <ArrowRight size={18} className="ml-2" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TelegramBlogSection;
